"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordField = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const web_core_form_text_field_1 = require("@opus/web.core.form.text-field");
const react_2 = require("react");
const ai_1 = require("react-icons/ai");
const react_3 = require("react");
const PasswordField = (props) => {
    const [visible, setVisible] = react_2.useState(false);
    const [type, Icon] = react_3.useMemo(() => (visible ? ['text', ai_1.AiOutlineEye] : ['password', ai_1.AiOutlineEyeInvisible]), [visible]);
    return (react_1.default.createElement(web_core_form_text_field_1.TextField, Object.assign({ type: type, autoComplete: "current-password", InputProps: {
            endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                react_1.default.createElement(core_1.IconButton, { edge: "end", onMouseDown: () => setVisible(!visible) },
                    react_1.default.createElement(Icon, null)))),
        } }, props)));
};
exports.PasswordField = PasswordField;
//# sourceMappingURL=password-field.js.map